import styled from 'styled-components'

export const Container = styled.div`
  width: 100%;
  max-height: 88vh;
  overflow: auto;
  padding: 25px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-top: 24px;
  align-items: center;
`